import {
  ExamCenterDetailsPageHeader,
  ExamCenterProvider,
} from '@exam-center/admin-exam-center-details';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { Box } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function AdminExamCenterLayout() {
  const { examCenterCode } = useParams('/admin/exam-centers/:examCenterCode/details');
  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.EXAM_CENTER.VIEW,
        APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.EXAM_COURSE.VIEW,
        APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.MEMBER.VIEW,
      ]}
      options={{ operator: 'OR' }}
    >
      <ExamCenterProvider examCenterCode={examCenterCode}>
        <ExamCenterDetailsPageHeader />
        <Box sx={{ p: (theme) => theme.spacing(6), flex: 1 }}>
          <Outlet />
        </Box>
      </ExamCenterProvider>
    </PermissionGuard>
  );
}
